<template>
  <div
    v-if="!$route.meta.hideNavigation"
    :class="$route.path !== '/' ? 'nonStartStyle' : 'startStyle'"
  >
    <v-row no-gutters class="pl-4" :class="$route.path === '/' ? 'pt-10' : ''">
      <v-breadcrumbs :items="breadCrumbs" v-if="$route.path !== '/'" large>
        <template v-slot:divider>
          <i class="fa-light fa-chevron-right breadcrumb-color"></i>
        </template>

        <template v-slot:item="{ item }">
          <v-breadcrumbs-item :href="item.href" :disabled="item.disabled">
            <!-- Hide the icons for the current route except for start page -->
            <div v-if="item.to !== '/'">
              <i
                v-if="item.text !== $route.name"
                class="fa-light fa-chevron-left breadcrumb-color"
              ></i>
              <i
                v-if="item.text !== $route.name"
                :class="currentIcon"
                class="current-route"
              ></i>
            </div>

            <!-- Breadcrumb text -->
            <div
              v-if="item.text !== $route.name"
              @click="specificPath(item.text)"
              class="cursor-style"
            >
              <i class="fa-light fa-objects-column pr-1 breadcrumb-color"></i>
              <span class="breadcrumb-color"> {{ item.text }}</span>
            </div>

            <!-- For nested routes -->
            <div
              v-if="
                item.text === 'Submit certificate request' ||
                item.text === 'Create registration'
              "
            >
              <span
                @click="specificPath(specialPath)"
                class="breadcrumb-color cursor-style"
                >{{ specialPath }}</span
              >
              <i class="fa-light fa-chevron-right pl-2 breadcrumb-color"></i>
            </div>

            <!-- current breadcrumb -->
            <span v-if="item.text === $route.name" class="pl-2 current-breadcrumb">
              {{ item.text }}</span
            >
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
    </v-row>
    <!-- Current route -->
    <v-row no-gutters class="pl-12 mb-5">
      <div>
        <v-btn icon @click="goBackClicked" v-if="$route.path !== '/'">
          <v-icon class="back-nav">fa-light fa-chevron-left</v-icon>
        </v-btn>
        <v-icon class="current-route current-icon">{{ currentIcon }}</v-icon>
        <span class="current-route current-text">
          {{ $route.name }}
        </span>
        <div class="d-inline" v-for="route in icons" :key="route.name">
          <tooltip-component
            v-if="route.name === $route.name && route.name !== 'Dashboard'"
            :text="route.msg"
          ></tooltip-component>
        </div>
      </div>
    </v-row>
  </div>
</template>
<script>
import TooltipComponent from "@/components/global/tooltip-component.vue";

export default {
  components: {
    TooltipComponent,
  },
  data() {
    return {
      icons: [
        {
          name: "Dashboard",
          icon: "fa-light fa-objects-column",
        },
        {
          name: "Certificates",
          icon: "fa-light fa-file-certificate",
          msg:
            "Manage your certificates – you can filter, view, revoke, reinstate, and download certificates. Use the filter pane to narrow down your search. You can also submit certificate requests.",
        },
        {
          name: "Submit certificate request",
          icon: "fa-light fa-circle-plus",
          msg:
            "Submit a certificate request (PKSC#10) to issue a certificate using the selected token procedure",
        },
        {
          name: "Registrations",
          icon: "fa-light fa-pen-field",
          msg:
            "Manage your registrations – you can search, view, and change the status of registrations. Use the filter pane to narrow down your search. You can also create registrations. Registrations enable devices to enroll for certificates using an API.",
        },
        {
          name: "Create registration",
          icon: "fa-light fa-circle-plus",
          msg:
            "Register a hardware device to enable certificate enrollment with the selected protocol API.",
        },
      ],
    };
  },
  computed: {
    breadCrumbs() {
      const breadcrumbs = [{ text: "Dashboard", to: "/" }];
      const matchedRoutes = this.$route.matched;
      matchedRoutes.forEach((route) => {
        if (route.path !== "/") {
          breadcrumbs.push({ text: route.name, to: route.path });
        }
      });
      return breadcrumbs;
    },
    currentIcon() {
      const currentIcon = this.icons.find((icon) => {
        return icon.name === this.$route.name;
      });
      return currentIcon ? currentIcon.icon : "";
    },
    specialPath() {
      let strings = this.$route.path;
      let specialString = strings.split("/")[1];
      let firstLetter = specialString.charAt(0);
      let firstCap = firstLetter.toUpperCase();
      let remainingLetters = specialString.slice(1);
      let finalString = firstCap + remainingLetters;
      return finalString;
    },
  },
  methods: {
    specificPath(path) {
      this.$router.push({ name: path });
    },
    goBackClicked() {
      if (this.$route.name === "Submit certificate request") {
        this.$router.push({ name: "Certificates" });
      } else if (this.$route.name === "Create registration") {
        this.$router.push({ name: "Registrations" });
      } else {
        if (this.breadCrumbs[0].to === "/") {
          this.$router.push({ name: this.breadCrumbs[0].text });
        }
      }
    },
  },
};
</script>
<style lang="scss">
.back-nav {
  color: #006ca1 !important;
  padding-right: 8px;
  font-size: 22px;
}
.current-breadcrumb {
  color: #c0c2c3 !important;
}
.current-icon {
  font-size: 25px !important;
}
.current-text {
  font-size: 1.875rem;
  vertical-align: middle;
}
.current-route {
  color: #003088 !important;
}
.breadcrumb-color {
  color: #006ca1;
}
.cursor-style {
  cursor: pointer;
}
.nonStartStyle {
  margin-bottom: -3rem;
}
.startStyle {
  margin-bottom: -2%;
}

@media only screen and (max-width: 960px) {
  .v-breadcrumbs--large li {
    font-size: 0.75rem !important;
  }
  .current-text {
    font-size: 1.5rem;
    vertical-align: middle;
  }
}

.v-breadcrumbs--large li {
  font-size: 0.875rem;
}

</style>
